const config = {
   // BASE_URL: 'http://localhost:5000',
    
   BASE_URL:"https://medic-serveur.onrender.com"
    
  };
    export default config;

